import curd from '../curd'

const BASE_PATH = '/configure/site/device'

export default curd(BASE_PATH, {

})



// WEBPACK FOOTER //
// ./src/apis/modules/SiteDevice.js